<template>
  <div v-loading="loading" class="text-black my-3">
    <div>
      <div class="flex justify-between items-center">
        <div class="flex justify-end">
          <div class="hodo-el">
            <el-select
              v-model="option"
              placeholder="Chọn loại"
              @change="showList"
            >
              <el-option
                v-for="item in optionSelect"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex">
          <div
            class="text-black fs-14 mr-3 cursor-pointer fw-600"
            @click="showModal(true)"
          >
            <svg
              class="mr-1"
              width="16"
              height="16"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.039 5.13579L8.1 3.06528V11.6984C8.1 11.9372 8.19482 12.1662 8.3636 12.335C8.53239 12.5038 8.76131 12.5987 9 12.5987C9.23869 12.5987 9.46761 12.5038 9.6364 12.335C9.80518 12.1662 9.9 11.9372 9.9 11.6984V3.06528L11.961 5.13579C12.0447 5.22017 12.1442 5.28714 12.2539 5.33284C12.3636 5.37855 12.4812 5.40208 12.6 5.40208C12.7188 5.40208 12.8364 5.37855 12.9461 5.33284C13.0558 5.28714 13.1553 5.22017 13.239 5.13579C13.3234 5.05211 13.3903 4.95254 13.436 4.84284C13.4817 4.73314 13.5052 4.61547 13.5052 4.49663C13.5052 4.37779 13.4817 4.26013 13.436 4.15043C13.3903 4.04073 13.3234 3.94116 13.239 3.85747L9.639 0.256576C9.55341 0.174619 9.45248 0.110375 9.342 0.067529C9.12288 -0.0225097 8.87712 -0.0225097 8.658 0.067529C8.54752 0.110375 8.44659 0.174619 8.361 0.256576L4.761 3.85747C4.67709 3.94141 4.61052 4.04106 4.56511 4.15072C4.51969 4.26039 4.49632 4.37793 4.49632 4.49663C4.49632 4.61534 4.51969 4.73288 4.56511 4.84254C4.61052 4.95221 4.67709 5.05186 4.761 5.13579C4.84491 5.21973 4.94454 5.28631 5.05418 5.33173C5.16382 5.37716 5.28133 5.40054 5.4 5.40054C5.51867 5.40054 5.63618 5.37716 5.74582 5.33173C5.85546 5.28631 5.95509 5.21973 6.039 5.13579ZM17.1 8.99776C16.8613 8.99776 16.6324 9.0926 16.4636 9.26142C16.2948 9.43025 16.2 9.65922 16.2 9.89798V15.2993C16.2 15.5381 16.1052 15.7671 15.9364 15.9359C15.7676 16.1047 15.5387 16.1996 15.3 16.1996H2.7C2.4613 16.1996 2.23239 16.1047 2.0636 15.9359C1.89482 15.7671 1.8 15.5381 1.8 15.2993V9.89798C1.8 9.65922 1.70518 9.43025 1.5364 9.26142C1.36761 9.0926 1.13869 8.99776 0.9 8.99776C0.661305 8.99776 0.432387 9.0926 0.263604 9.26142C0.0948211 9.43025 0 9.65922 0 9.89798V15.2993C0 16.0156 0.284464 16.7025 0.790812 17.209C1.29716 17.7155 1.98392 18 2.7 18H15.3C16.0161 18 16.7028 17.7155 17.2092 17.209C17.7155 16.7025 18 16.0156 18 15.2993V9.89798C18 9.65922 17.9052 9.43025 17.7364 9.26142C17.5676 9.0926 17.3387 8.99776 17.1 8.99776Z"
                fill="#03267A"
              />
            </svg>
            Upload Phiếu
          </div>
          <div class="flex cursor-pointer items-center" @click="createForm">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="mr-2"
            >
              <path
                d="M8.99984 0.666748C7.35166 0.666748 5.7405 1.15549 4.37009 2.07117C2.99968 2.98685 1.93158 4.28834 1.30084 5.81105C0.670115 7.33377 0.505087 9.00933 0.82663 10.6258C1.14817 12.2423 1.94185 13.7272 3.10728 14.8926C4.27272 16.0581 5.75758 16.8517 7.37409 17.1733C8.9906 17.4948 10.6662 17.3298 12.1889 16.6991C13.7116 16.0683 15.0131 15.0002 15.9288 13.6298C16.8444 12.2594 17.3332 10.6483 17.3332 9.00008C17.3332 7.90573 17.1176 6.8221 16.6988 5.81105C16.28 4.80001 15.6662 3.88135 14.8924 3.10752C14.1186 2.3337 13.1999 1.71987 12.1889 1.30109C11.1778 0.882296 10.0942 0.666748 8.99984 0.666748ZM8.99984 15.6667C7.6813 15.6667 6.39237 15.2758 5.29604 14.5432C4.19971 13.8107 3.34523 12.7695 2.84064 11.5513C2.33606 10.3331 2.20404 8.99269 2.46127 7.69948C2.71851 6.40627 3.35345 5.21839 4.2858 4.28604C5.21815 3.35369 6.40603 2.71875 7.69924 2.46151C8.99245 2.20428 10.3329 2.3363 11.5511 2.84088C12.7692 3.34547 13.8104 4.19995 14.543 5.29628C15.2755 6.39261 15.6665 7.68154 15.6665 9.00008C15.6665 10.7682 14.9641 12.4639 13.7139 13.7141C12.4636 14.9644 10.768 15.6667 8.99984 15.6667ZM12.3332 8.16675H9.83317V5.66675C9.83317 5.44573 9.74538 5.23377 9.5891 5.07749C9.43282 4.92121 9.22085 4.83342 8.99984 4.83342C8.77883 4.83342 8.56687 4.92121 8.41059 5.07749C8.25431 5.23377 8.16651 5.44573 8.16651 5.66675V8.16675H5.66651C5.44549 8.16675 5.23353 8.25455 5.07725 8.41083C4.92097 8.56711 4.83317 8.77907 4.83317 9.00008C4.83317 9.2211 4.92097 9.43306 5.07725 9.58934C5.23353 9.74562 5.44549 9.83342 5.66651 9.83342H8.16651V12.3334C8.16651 12.5544 8.25431 12.7664 8.41059 12.9227C8.56687 13.079 8.77883 13.1667 8.99984 13.1667C9.22085 13.1667 9.43282 13.079 9.5891 12.9227C9.74538 12.7664 9.83317 12.5544 9.83317 12.3334V9.83342H12.3332C12.5542 9.83342 12.7662 9.74562 12.9224 9.58934C13.0787 9.43306 13.1665 9.2211 13.1665 9.00008C13.1665 8.77907 13.0787 8.56711 12.9224 8.41083C12.7662 8.25455 12.5542 8.16675 12.3332 8.16675Z"
                fill="#03267A"
              />
            </svg>
            <span class="fs-14 fw-700 txt-grey-900">Thêm Phiếu mới</span>
          </div>
        </div>
      </div>

      <div class="mt-1">
        <el-table
          v-loading="is_loading || loadingList"
          :data="nutri"
          :default-sort="{ prop: 'date', order: 'descending' }"
          style="width: 100%"
          row-class-name="text-black text-sm"
          header-cell-class-name="text-black text-base font-semibold"
          class="cursor-pointer handleLoading"
          @row-click="showDetail"
        >
          <el-table-column
            label="Tên phiếu"
            prop="name"
            width="500px"
          ></el-table-column>
          <el-table-column
            v-if="option === 'all'"
            label="Loại phiếu"
            prop="type"
            :formatter="nutriType"
          ></el-table-column>
          <el-table-column
            :formatter="formatDateTime"
            label="Ngày đánh giá"
            prop="date"
          ></el-table-column>
          <!-- <el-table-column
            label="Loại phiếu"
            class-name="text-center"
            width="240px"
          >
          </el-table-column>-->
        </el-table>
        <div class="flex justify-content-end mt-3">
          <el-pagination
            v-if="nutri"
            background
            layout="prev, pager, next"
            :total="nutriPaging.total"
            :page-size="parseInt(nutriPaging.per_page)"
            @current-change="handleCurrentPage"
          ></el-pagination>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="modalCreatePDD"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalCreatePDDLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-form modal-xl" role="document">
        <div class="modal-content" v-loading="loadingList">
          <div class="text-center fs-22 fw-700 mt-3">
            <div class="flex justify-end mr-3">
              <button
                type="button"
                class="close bg-white border-0"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true" class="fs-30 fw-500">&times;</span>
              </button>
            </div>
            <div>
              <span v-if="has_option === 1"
                >PHIẾU ĐÁNH GIÁ DINH DƯỠNG CỦA BỆNH NHÂN NẰM VIỆN</span
              >
              <span v-if="has_option === 2"
                >PHIẾU ĐÁNH GIÁ DINH DƯỠNG CỦA BỆNH NHÂN NHẬP VIỆN</span
              >
            </div>
          </div>

          <div class="flex justify-end">
            <select
              v-model="has_option"
              class="p-2.5 border-grey-400 rounded-lg mr-3 cursor-pointer"
            >
              <option :value="1">Người bệnh nằm viện</option>
              <option :value="2">Người nhập viện</option>
            </select>
          </div>
          <div class="modal-body">
            <PhieuDangNamVien
              :loadingList="loadingList"
              @onCreate="onCreate($event)"
              v-if="has_option === 1"
            />
            <PhieuNhapVien
              v-if="has_option === 2"
              :loadingList="loadingList"
              @onCreate="onCreate($event)"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- create -->
    <div
      class="modal fade"
      id="modalPDF"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalPDFLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sx" role="document">
        <div class="modal-content" v-loading="is_loading">
          <div class="d-flex justify-content-between p-3">
            <div class="fs-24 fw-700 txt-grey-900 text-center w-100">
              <span>Đánh giá dinh dưỡng</span>
            </div>
            <!-- <button
            type="button"
            class="close bg-white border-0"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span
              aria-hidden="true"
              class="fs-30 fw-500"
            >&times;</span>
            </button>-->
          </div>
          <div class="modal-body">
            <div class="mb-3 row">
              <div class="col-md-4">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">Tên phiếu:</p>
              </div>
              <div class="col-md-8">
                <el-input
                  v-model="form.name"
                  class="w-100 col-md-5"
                  placeholder="Nhập Tên"
                ></el-input>
              </div>
            </div>
            <div class="mb-3 row">
              <div class="col-md-4">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">Ngày giờ:</p>
              </div>
              <div class="col-md-8">
                <input
                  v-model="form.date"
                  type="datetime-local"
                  class="form-control fw-500 txt-grey-900"
                />
              </div>
            </div>

            <div class="mb-3 row">
              <div class="col-md-4">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">Chọn loại:</p>
              </div>
              <div class="col-md-8">
                <el-select v-model="optionCreate" placeholder="Chọn loại">
                  <template v-for="item in optionSelect">
                    <el-option
                      v-if="!item.disabled"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </template>
                </el-select>
              </div>
            </div>

            <div class="mb-3 row" v-if="optionCreate === 1">
              <div class="col-md-4">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">
                  Bác sĩ điều trị:
                </p>
              </div>
              <div class="col-md-8">
                <el-select
                  v-model="form.doctor_id"
                  allow-create
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Tìm kiếm tên bác sĩ"
                  class="w-100"
                  :remote-method="getDoctor"
                  :loading="loadingDoctor"
                >
                  <el-option
                    v-for="item in doctors"
                    :key="item.id + 'dtr'"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="mb-3 row" v-if="optionCreate === 2">
              <div class="col-md-4">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">
                  Bác sĩ khám bệnh:
                </p>
              </div>
              <div class="col-md-8">
                <el-select
                  v-model="form.doctor_id"
                  allow-create
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Tìm kiếm tên bác sĩ"
                  class="w-100"
                  :remote-method="getDoctor"
                  :loading="loadingDoctor"
                >
                  <el-option
                    v-for="item in doctors"
                    :key="item.id + 'dtr'"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <div class="mb-3 row">
              <div class="col-md-9">
                <p class="mt-2 fs-14">
                  {{ file ? file.name : "Chưa chọn file..." }}
                </p>
              </div>
              <div class="col-md-3">
                <div
                  v-if="file"
                  @click="showPickFilePDD"
                  class="mt-3 ml-4 fs-16 text-blue-900 underline cursor-pointer hover:text-blue-500"
                >
                  Thay đổi
                </div>
                <button
                  v-if="!file"
                  @click="showPickFilePDD"
                  type="button"
                  class="btn bg-pri text-white mt-2"
                >
                  <svg
                    width="16"
                    height="20"
                    viewBox="0 0 16 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.78945 6.42495L7.31161 4.50829V12.5C7.31161 12.721 7.38164 12.9329 7.50629 13.0892C7.63095 13.2455 7.80002 13.3333 7.9763 13.3333C8.15259 13.3333 8.32166 13.2455 8.44632 13.0892C8.57097 12.9329 8.641 12.721 8.641 12.5V4.50829L10.1632 6.42495C10.2249 6.50306 10.2985 6.56506 10.3795 6.60736C10.4605 6.64967 10.5473 6.67145 10.6351 6.67145C10.7228 6.67145 10.8097 6.64967 10.8907 6.60736C10.9717 6.56506 11.0452 6.50306 11.107 6.42495C11.1693 6.34749 11.2188 6.25532 11.2525 6.15377C11.2863 6.05222 11.3036 5.9433 11.3036 5.83329C11.3036 5.72328 11.2863 5.61436 11.2525 5.51281C11.2188 5.41126 11.1693 5.31909 11.107 5.24162L8.44824 1.90829C8.38502 1.83242 8.31048 1.77295 8.22889 1.73329C8.06706 1.64994 7.88555 1.64994 7.72372 1.73329C7.64213 1.77295 7.56759 1.83242 7.50437 1.90829L4.84559 5.24162C4.78361 5.31932 4.73445 5.41156 4.70091 5.51308C4.66737 5.6146 4.65011 5.72341 4.65011 5.83329C4.65011 5.94317 4.66737 6.05198 4.70091 6.1535C4.73445 6.25501 4.78361 6.34726 4.84559 6.42495C4.90756 6.50265 4.98114 6.56429 5.06211 6.60634C5.14309 6.64839 5.22987 6.67003 5.31752 6.67003C5.40517 6.67003 5.49196 6.64839 5.57293 6.60634C5.6539 6.56429 5.72748 6.50265 5.78945 6.42495ZM13.9586 11.6666C13.7823 11.6666 13.6132 11.7544 13.4886 11.9107C13.3639 12.067 13.2939 12.2789 13.2939 12.5V15.8333C13.2939 16.0543 13.2238 16.2663 13.0992 16.4225C12.9745 16.5788 12.8055 16.6666 12.6292 16.6666H3.32343C3.14714 16.6666 2.97808 16.5788 2.85342 16.4225C2.72877 16.2663 2.65874 16.0543 2.65874 15.8333V12.5C2.65874 12.2789 2.58871 12.067 2.46405 11.9107C2.3394 11.7544 2.17033 11.6666 1.99404 11.6666C1.81775 11.6666 1.64869 11.7544 1.52403 11.9107C1.39938 12.067 1.32935 12.2789 1.32935 12.5V15.8333C1.32935 16.4963 1.53944 17.1322 1.9134 17.6011C2.28736 18.0699 2.79457 18.3333 3.32343 18.3333H12.6292C13.158 18.3333 13.6652 18.0699 14.0392 17.6011C14.4132 17.1322 14.6233 16.4963 14.6233 15.8333V12.5C14.6233 12.2789 14.5532 12.067 14.4286 11.9107C14.3039 11.7544 14.1349 11.6666 13.9586 11.6666Z"
                      fill="white"
                    />
                  </svg>
                  Chọn file
                </button>
                <input
                  class="d-none"
                  id="inputFilePDD"
                  type="file"
                  @change="selectFilePDD"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              id="closeModal"
              type="button"
              class="btn bg-white text-blue-900"
              data-dismiss="modal"
              @click="closeModal"
            >
              Hủy
            </button>
            <button
              @click="onUpload"
              type="button"
              class="btn bg-pri text-white"
            >
              Lưu
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- detail/update -->
    <div
      class="modal fade"
      id="modalPDF"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalPDFLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sx" role="document">
        <div class="modal-content" v-loading="is_loading">
          <div class="d-flex justify-content-between p-3">
            <div class="fs-24 fw-700 txt-grey-900 text-center w-100">
              <span>Đánh giá dinh dưỡng</span>
            </div>
            <!-- <button
            type="button"
            class="close bg-white border-0"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span
              aria-hidden="true"
              class="fs-30 fw-500"
            >&times;</span>
            </button>-->
          </div>
          <div class="modal-body">
            <div class="mb-3 row">
              <div class="col-md-4">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">Tên phiếu:</p>
              </div>
              <div class="col-md-8">
                <el-input
                  v-model="form.name"
                  class="w-100 col-md-5"
                  placeholder="Nhập Tên"
                ></el-input>
              </div>
            </div>
            <div class="mb-3 row">
              <div class="col-md-4">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">Ngày giờ:</p>
              </div>
              <div class="col-md-8">
                <input
                  v-model="form.date"
                  type="datetime-local"
                  class="form-control fw-500 txt-grey-900"
                />
              </div>
            </div>

            <div class="mb-3 row">
              <div class="col-md-4">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">Chọn loại:</p>
              </div>
              <div class="col-md-8">
                <el-select v-model="optionCreate" placeholder="Chọn loại">
                  <template v-for="item in optionSelect">
                    <el-option
                      v-if="!item.disabled"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </template>
                </el-select>
              </div>
            </div>

            <div class="mb-3 row" v-if="optionCreate === 1">
              <div class="col-md-4">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">
                  Bác sĩ điều trị:
                </p>
              </div>
              <div class="col-md-8">
                <el-select
                  v-model="form.doctor_id"
                  allow-create
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Tìm kiếm tên bác sĩ"
                  class="w-100"
                  :remote-method="getDoctor"
                  :loading="loadingDoctor"
                >
                  <el-option
                    v-for="item in doctors"
                    :key="item.id + 'dtr'"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="mb-3 row" v-if="optionCreate === 2">
              <div class="col-md-4">
                <p class="mb-1 fs-16 txt-grey-900 fw-700 mt-2">
                  Bác sĩ khám bệnh:
                </p>
              </div>
              <div class="col-md-8">
                <el-select
                  v-model="form.doctor_id"
                  allow-create
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Tìm kiếm tên bác sĩ"
                  class="w-100"
                  :remote-method="getDoctor"
                  :loading="loadingDoctor"
                >
                  <el-option
                    v-for="item in doctors"
                    :key="item.id + 'dtr'"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <div class="mb-3 row">
              <div class="col-md-9">
                <p class="mt-2 fs-14">
                  {{ file ? file.name : "Chưa chọn file..." }}
                </p>
              </div>
              <div class="col-md-3">
                <div
                  v-if="file"
                  @click="showPickFilePDD"
                  class="mt-3 ml-4 fs-16 text-blue-900 underline cursor-pointer hover:text-blue-500"
                >
                  Thay đổi
                </div>
                <button
                  v-if="!file"
                  @click="showPickFilePDD"
                  type="button"
                  class="btn bg-pri text-white mt-2"
                >
                  <svg
                    width="16"
                    height="20"
                    viewBox="0 0 16 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.78945 6.42495L7.31161 4.50829V12.5C7.31161 12.721 7.38164 12.9329 7.50629 13.0892C7.63095 13.2455 7.80002 13.3333 7.9763 13.3333C8.15259 13.3333 8.32166 13.2455 8.44632 13.0892C8.57097 12.9329 8.641 12.721 8.641 12.5V4.50829L10.1632 6.42495C10.2249 6.50306 10.2985 6.56506 10.3795 6.60736C10.4605 6.64967 10.5473 6.67145 10.6351 6.67145C10.7228 6.67145 10.8097 6.64967 10.8907 6.60736C10.9717 6.56506 11.0452 6.50306 11.107 6.42495C11.1693 6.34749 11.2188 6.25532 11.2525 6.15377C11.2863 6.05222 11.3036 5.9433 11.3036 5.83329C11.3036 5.72328 11.2863 5.61436 11.2525 5.51281C11.2188 5.41126 11.1693 5.31909 11.107 5.24162L8.44824 1.90829C8.38502 1.83242 8.31048 1.77295 8.22889 1.73329C8.06706 1.64994 7.88555 1.64994 7.72372 1.73329C7.64213 1.77295 7.56759 1.83242 7.50437 1.90829L4.84559 5.24162C4.78361 5.31932 4.73445 5.41156 4.70091 5.51308C4.66737 5.6146 4.65011 5.72341 4.65011 5.83329C4.65011 5.94317 4.66737 6.05198 4.70091 6.1535C4.73445 6.25501 4.78361 6.34726 4.84559 6.42495C4.90756 6.50265 4.98114 6.56429 5.06211 6.60634C5.14309 6.64839 5.22987 6.67003 5.31752 6.67003C5.40517 6.67003 5.49196 6.64839 5.57293 6.60634C5.6539 6.56429 5.72748 6.50265 5.78945 6.42495ZM13.9586 11.6666C13.7823 11.6666 13.6132 11.7544 13.4886 11.9107C13.3639 12.067 13.2939 12.2789 13.2939 12.5V15.8333C13.2939 16.0543 13.2238 16.2663 13.0992 16.4225C12.9745 16.5788 12.8055 16.6666 12.6292 16.6666H3.32343C3.14714 16.6666 2.97808 16.5788 2.85342 16.4225C2.72877 16.2663 2.65874 16.0543 2.65874 15.8333V12.5C2.65874 12.2789 2.58871 12.067 2.46405 11.9107C2.3394 11.7544 2.17033 11.6666 1.99404 11.6666C1.81775 11.6666 1.64869 11.7544 1.52403 11.9107C1.39938 12.067 1.32935 12.2789 1.32935 12.5V15.8333C1.32935 16.4963 1.53944 17.1322 1.9134 17.6011C2.28736 18.0699 2.79457 18.3333 3.32343 18.3333H12.6292C13.158 18.3333 13.6652 18.0699 14.0392 17.6011C14.4132 17.1322 14.6233 16.4963 14.6233 15.8333V12.5C14.6233 12.2789 14.5532 12.067 14.4286 11.9107C14.3039 11.7544 14.1349 11.6666 13.9586 11.6666Z"
                      fill="white"
                    />
                  </svg>
                  Chọn file
                </button>
                <input
                  class="d-none"
                  id="inputFileePDD"
                  type="file"
                  @change="selectFilePDD"
                  :key="fileInputKey"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              id="closeModal"
              type="button"
              class="btn bg-white text-blue-900"
              data-dismiss="modal"
              @click="closeModal"
            >
              Hủy
            </button>
            <button
              @click="onUpload"
              type="button"
              class="btn bg-pri text-white"
            >
              Lưu
            </button>
          </div>
        </div>
      </div>
    </div>

    <template v-if="option === 'all'">
      <PhieuNamVienDetail
        @refresh="getNutritionHospitalById"
        @refreshList="getAllNutritionData"
        :data="nutriDetail"
      />
      <PhieuNhapVienDetail
        @refresh="getNutritionAdmissionsById"
        @refreshList="getAllNutritionData"
        :data="nutriDetail"
      />
      <ModalViewPNV
        v-if="selectedItem && selectedItem.type === 1"
        :loading="is_loading"
        @refresh="getNutritionHospitalById"
        @refreshList="getAllNutritionData"
        :data="nutriDetail"
        :type="'NamVien'"
        @onSubmit="onUpdate($event)"
      />
      <ModalViewPNV
        v-if="selectedItem && selectedItem.type === 2"
        :loading="is_loading"
        @refresh="getNutritionAdmissionsById"
        @refreshList="getAllNutritionData"
        :data="nutriDetail"
        :type="'NhapVien'"
        @onSubmit="onUpdate($event)"
      />
    </template>
    <template v-else>
      <PhieuNamVienDetail
        v-if="option === 1"
        @refresh="getNutritionHospital"
        @refreshList="getNutritionHospital"
        :data="nutriDetail"
      />
      <PhieuNhapVienDetail
        v-if="option === 2"
        @refresh="getNutritionAdmissions"
        @refreshList="getNutritionAdmissions"
        :data="nutriDetail"
      />
      <ModalViewPNV
        v-if="option === 1"
        :loading="is_loading"
        @refresh="getNutritionHospitalById"
        @refreshList="getNutritionHospital"
        :data="nutriDetail"
        :type="'NamVien'"
        @onSubmit="onUpdate($event)"
      />
      <ModalViewPNV
        v-if="option === 2"
        :loading="is_loading"
        @refresh="getNutritionAdmissionsById"
        @refreshList="getNutritionAdmissions"
        :data="nutriDetail"
        :type="'NhapVien'"
        @onSubmit="onUpdate($event)"
      />
    </template>
    <PdfViewer
      ref="NutritionalFormPdfViewer"
      containerIDProps="ContainerNutritionalFormPDFViewerID"
      elementIDProps="NutritionalFormPDFViewerID"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import PhieuDangNamVien from './PhieuDangNamVien.vue'
import ModalViewPNV from './ViewPDD.vue'
import PhieuNhapVien from './PhieuNhapVien.vue'
import PhieuNamVienDetail from './PhieuDangNamVienDetail.vue'
import PhieuNhapVienDetail from './PhieuNhapVienDetail'
import appUtils from '../../../utils/appUtils'
import { ENVELOPE_DOCUMENT_TYPE } from '../../../utils/constants'
import SignatureRequest from '../../../api/request/SignatureRequest'
import PdfViewer from '../../PdfViewer/PdfViewer.vue'

export default {
  name: 'PhieuDinhDuongList',
  components: {
    PhieuDangNamVien,
    PhieuNhapVien,
    PhieuNamVienDetail,
    PhieuNhapVienDetail,
    ModalViewPNV,
    PdfViewer
  },
  data () {
    return {
      optionCreate: null,
      loadingDoctor: false,
      is_loading: false,
      nutri: null,
      idPhieu: null,
      nutriDetail: {},
      nutriPaging: {},
      loadingList: false,
      has_option: 1,
      option: 'all',
      file: null,
      doctors: [],
      form: {
        doctor_id: '',
        medical_record_id: null,
        name:
          'Phiếu đánh giá dinh dưỡng ' + window.moment().format('DD/MM/YYYY'),
        date: moment().format('YYYY-MM-DD HH:mm')
      },
      optionSelect: [
        {
          value: 'all',
          label: 'Tất cả',
          disabled: true
        },
        {
          value: 1,
          label: 'Người nằm viện'
        },
        {
          value: 2,
          label: 'Người nhập viện'
        }
      ],
      selectedItem: {},
      fileInputKey: 0,
      loading: false
    }
  },
  mounted () {
    let self = this
    if (self.option === 'all') {
      self.getAllNutritionData()
    }
    self.getDoctor()
    self.$nextTick(function () {
      window.$('#modalPDF').on('hidden.bs.modal', function (e) {
        self.refresh()
      })
    })
  },
  methods: {
    async onUpdate (event) {
      const form = {
        medical_record_id: this.$route.params.id,
        ...event
      }
      const formData = new FormData()
      for (const key in form) {
        formData.append(key, form[key] || '')
      }
      this.is_loading = true

      const updateWithType = async (type) => {
        if (type === 1) {
          await this.$rf
            .getRequest('DoctorRequest')
            .postNutritionHospitalById(this.idPhieu, formData)
            .then((r) => {
              this.$toast.open({
                message: 'Cập nhật thành công',
                type: 'success'
              })
            })
            .finally(() => {
              this.is_loading = false
            })
          await this.getNutritionHospitalById()
        }
        if (type === 2) {
          await this.$rf
            .getRequest('DoctorRequest')
            .updateNutritionAdmissions(this.idPhieu, formData)
            .then((r) => {
              this.$toast.open({
                message: 'Cập nhật thành công',
                type: 'success'
              })
            })
            .finally(() => {
              this.is_loading = false
            })
          await this.getNutritionAdmissionsById()
        }
      }

      await updateWithType(
        (this.option === 'all' && this.selectedItem?.type) || this.option
      )
    },
    handleCurrentPage (page) {
      let query = Object.assign({}, this.$route.query)
      query.page = page
      this.$router.replace({ query }).catch((_) => {})
      if (this.option === 1) {
        this.getNutritionHospital()
      } else {
        this.getNutritionAdmissions()
      }
    },
    getFilename (fullPath) {
      if (!_.isString(fullPath)) return
      return fullPath.split('/').pop()
    },
    getDoctor (search = null) {
      if (this.$globalClinic) {
        if (this.$globalClinic?.org_id) {
          this.getOrgDoctor(search)
        } else {
          this.getClinicDoctor(search)
        }
      }
    },
    async getOrgDoctor (search = null) {
      const params = {
        limit: 50
      }
      if (search) {
        params.search = search
      }
      this.loadingDoctor = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getOrgDoctor(this.$globalClinic?.org_id, params)
        .then((r) => {
          this.doctors = r.data
          const hasMe = this.doctors.find((d) => d.user_id === this.$user.id)
          if (!hasMe && this.$user.doctor) this.doctors.push(this.$user.doctor)
          this.doctorPaging = r.meta
        })
        .finally(() => {
          this.loadingDoctor = false
        })
    },
    async getClinicDoctor (search) {
      const params = {
        limit: 50
      }
      if (search) {
        params.search = search
      }
      this.loadingDoctor = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getClinicDoctor(this.$globalClinic?.id, params)
        .then((r) => {
          this.doctors = r.data.data
          this.doctors.map((d) => {
            d.name = d.doctor?.name
            d.user_id = d.doctor?.user_id
          })
          const hasMe = this.doctors.find(
            (d) => d.doctor_id === this.$user?.doctor.id
          )
          if (!hasMe && this.$user.doctor) this.doctors.push(this.$user.doctor)
          this.doctorPaging = {
            count: r.data.count,
            current_page: r.data.current_page,
            last_page: r.data.last_page,
            per_page: r.data.per_page,
            total: r.data.total
          }
        })
        .finally(() => {
          this.loadingDoctor = false
        })
    },
    async createSurgery (event) {
      this.loading = true
      const params = {
        ...event
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .createSurgery(this.$route.params.id, params)
        .then((r) => {
          const dataId = r.data?.id
          this.getSurgeries()
          this.$router.push({
            query: { tab: this.$route.query.tab, vId: dataId, type: 'view' }
          })
          this.$toast.open({
            message: 'Thêm thành công',
            type: 'success'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    refresh () {
      const fileInput = document.getElementById('inputFileePDD')

      this.file = null
      fileInput.value = ''
      this.fileInputKey++
      this.form = {
        medical_record_id: null,
        name:
          'Phiếu đánh giá dinh dưỡng ' + window.moment().format('DD/MM/YYYY'),
        date: moment().format('YYYY-MM-DD HH:mm')
      }
    },
    selectFilePDD (event) {
      console.log(event.target.files)
      this.file = event.target.files[0]
    },
    showPickFilePDD () {
      window.$('input[id="inputFileePDD"]').trigger('click')
    },
    closeModal () {
      this.file = null
      this.form = {}
      this.refresh()
    },
    showList () {
      switch (this.option) {
        case 1:
          this.getNutritionHospital()
          break
        case 2:
          this.getNutritionAdmissions()
          break

        default:
          this.getAllNutritionData()
          break
      }
    },
    async onUpload () {
      if (isNaN(this.form.doctor_id)) {
        this.form.doctor_name = this.form.doctor_id
        this.form.doctor_id = null
      }

      const params = {
        ...this.form,
        medical_record_id: this.$route.params.id,
        pdf: this.file
      }
      if (!this.optionCreate) {
        return alert('Chọn loại phiếu')
      }
      if (!this.file) {
        return alert('Chưa chọn file')
      }
      const formData = new FormData()
      if (this.optionCreate === 2) {
        for (const key in params) {
          formData.append(key, params[key] || '')
        }
        this.is_loading = true
        await this.$rf
          .getRequest('DoctorRequest')
          .postNutritionAdmissions(this.$route.params.id, formData)
          .then((r) => {
            this.getNutritionAdmissions()
            window.$('button#closeModal').trigger('click')
            this.option = 2
            this.closeModal()
            this.$toast.open({
              message: 'Upload file thành công',
              type: 'success'
            })
          })
          .finally(() => {
            this.is_loading = false
          })
      } else {
        for (const key in params) {
          formData.append(key, params[key] || '')
        }
        this.is_loading = true
        await this.$rf
          .getRequest('DoctorRequest')
          .postNutritionHospital(this.$route.params.id, formData)
          .then((r) => {
            this.getNutritionHospital()
            window.$('button#closeModal').trigger('click')
            this.option = 1
            this.closeModal()
            this.$toast.open({
              message: 'Upload file thành công',
              type: 'success'
            })
          })
          .finally(() => {
            this.is_loading = false
          })
      }
    },
    async showDetail (row) {
      this.idPhieu = row.id
      this.selectedItem = row

      this.loading = true
      const url = await this.handleGetEnvelopeByDocumentID(row)
      this.loading = false

      if (url) {
        this.$refs.NutritionalFormPdfViewer.handleOpen(
          url,
          ENVELOPE_DOCUMENT_TYPE.NUTRITIONAL_FORM,
          row.id
        )

        return
      }

      const getDataWithType = (type) => {
        if (type === 1) {
          this.getNutritionHospitalById()
        }

        if (type === 2) {
          this.getNutritionAdmissionsById()
        }
      }

      if (row?.pdf_url) {
        getDataWithType(Number(row?.type) || this.option)
        window.$('#modalViewUploadPDD').modal(row.pdf_url ? 'show' : 'hide')
        return
      }

      if (Number(row?.type) === 1 || this.option === 1) {
        getDataWithType(Number(row?.type) || this.option)
        window.$('#modalPhieuNamVienDetail').modal(row.id ? 'show' : 'hide')
        return
      }

      if (Number(row?.type) === 2 || this.option === 2) {
        getDataWithType(Number(row?.type) || this.option)
        window.$('#modalPhieuNhapVienDetail').modal(row.id ? 'show' : 'hide')
      }
    },
    showDetailNhapVien (show) {
      window.$('#modalPhieuNhapVienDetail').modal(show ? 'show' : 'hide')
    },
    showDetailNamVien (show) {
      window.$('#modalPhieuNamVienDetail').modal(show ? 'show' : 'hide')
    },
    async getNutritionHospitalById () {
      this.is_loading = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getNutritionHospitalById(this.idPhieu)
        .then((r) => {
          this.nutriDetail = r.data
        })
        .finally(() => {
          this.is_loading = false
        })
    },
    showModal (show) {
      window.$('#modalPDF').modal(show ? 'show' : 'hide')
    },
    async getAllNutritionData () {
      this.loadingList = true
      const params = {
        limit: 50,
        page: this.$route.query.page || 1,
        sort: 'date',
        sort_by: 'desc'
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .getAllNutrition(this.$route.params.id, params)
        .then((r) => {
          this.nutri = r.data
          this.nutriPaging = r.meta
        })
        .finally(() => {
          this.loadingList = false
        })
    },
    async getNutritionHospital () {
      this.loadingList = true
      const params = {
        limit: 50,
        page: this.$route.query.page || 1,
        sort: 'date',
        sort_by: 'desc'
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .getNutritionHospital(this.$route.params.id, params)
        .then((r) => {
          this.nutri = r.data
          this.nutriPaging = r.meta
        })
        .finally(() => {
          this.loadingList = false
        })
    },
    async getNutritionAdmissions () {
      this.loadingList = true
      const params = {
        limit: 50,
        page: this.$route.query.page || 1,
        sort: 'date',
        sort_by: 'desc'
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .getNutritionAdmissions(this.$route.params.id, params)
        .then((r) => {
          this.nutri = r.data
          this.nutriPaging = r.meta
        })
        .finally(() => {
          this.loadingList = false
        })
    },
    async getNutritionAdmissionsById () {
      this.loadingList = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getNutritionAdmissionsById(this.idPhieu)
        .then((r) => {
          this.nutriDetail = r.data
        })
        .finally(() => {
          this.loadingList = false
        })
    },
    // create
    createForm (show) {
      window.$('#modalCreatePDD').modal(show ? 'show' : 'hide')
    },
    async onCreate (event) {
      const id = this.$route.params.id
      if (this.has_option === 1) {
        this.loadingList = true
        const params = {
          medical_record_id: this.$route.params.id,
          ...event
        }
        await this.$rf
          .getRequest('DoctorRequest')
          .postNutritionHospital(id, params)
          .then((r) => {
            const res = r.data
            this.option = 1
            this.idPhieu = res.id
            this.getNutritionHospitalById()
            this.showDetailNamVien(true)
            this.getNutritionHospital()
            this.createForm(false)
          })
          .finally(() => {
            this.loadingList = false
          })
      }
      if (this.has_option === 2) {
        this.loadingList = true
        const params = {
          medical_record_id: this.$route.params.id,
          ...event
        }
        await this.$rf
          .getRequest('DoctorRequest')
          .postNutritionAdmissions(id, params)
          .then((r) => {
            this.option = 2
            const res = r.data
            this.idPhieu = res.id
            this.getNutritionAdmissionsById()
            this.showDetailNhapVien(true)
            this.getNutritionAdmissions()
            this.createForm(false)
          })
          .finally(() => {
            this.loadingList = false
          })
      }
      self.getAllNutritionData()
    },
    formatDateTime (row) {
      return appUtils.formatDateTimeFull(row.date)
    },
    nutriType (row) {
      if (!row) return ''

      if (row?.type === 1 || this.option === 1) {
        return this.$t('Người nằm viện')
      }
      if (row?.type === 2 || this.option === 2) {
        return this.$t('Người nhập viện')
      }
    },
    async handleGetEnvelopeByDocumentID (item) {
      if (!item?.id) return

      try {
        this.loading = true
        const request = new SignatureRequest()
        const response = await request.getSignEnvelopeByDocumentID({
          doc_id: item.id,
          doc_type: ENVELOPE_DOCUMENT_TYPE.NUTRITIONAL_FORM
        })

        return response.data?.document_url
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.handleLoading {
  z-index: 0;
}

.hodo-el /deep/ .el-input__inner {
  background: white !important;
  border: 1px solid #dee2e6 !important;
}
</style>
